<template>
    <div class="main-admin-component">
        <or-admin-header @logout="logout"/>
        <div class="body flex-row">
            <or-admin-menu ref="menu" @selected="({page})=>selected_page = page" :loaded="loaded"/>
            <p class="warn" v-show="unsaved.includes(selected_page)">Изменения не сохранены!</p>
            <or-admin-save-button :options="options[selected_page]" :selected_page="selected_page" :deleted="options.deleted" v-if="auth === true"/>
            <or-admin-auth ref="auth" @successful="login" v-if="auth === false"/>
            <or-admin-content ref="content" v-else>
                <slot>
                    <or-admin-main v-show="selected_page === 'main'" :options="options.main" @unsaved="push_unsaved('main')"/>
                    <or-admin-about v-show="selected_page === 'about'" :options="options.about" @unsaved="push_unsaved('about')"/>
                    <or-admin-production v-show="selected_page === 'production'" :options="options.production" :categories="production_categories" :deleted="options.deleted.production" @unsaved="push_unsaved('production')"/>
                    <or-admin-buyers v-show="selected_page === 'buyers'" :options="options.buyers" :categories="buyers_categories" :deleted="options.deleted.buyers" @unsaved="push_unsaved('buyers')"/>
                    <or-admin-news v-show="selected_page === 'news'" :options="options.news" :deleted="options.deleted.news" @unsaved="push_unsaved('news')"/>
                    <or-admin-contacts v-show="selected_page === 'contacts'" :options="options.contacts" @unsaved="push_unsaved('contacts')"/>
                    <or-admin-products v-show="selected_page === 'products'" :options="options.products" :deleted="options.deleted.products" @unsaved="push_unsaved('products')"/>
                    <or-admin-info v-show="selected_page === 'info'" :options="options.info" @unsaved="push_unsaved('info')"/>
                </slot>

            </or-admin-content>
            <transition name="fade">
                <img v-show="show_menu_button" src="../../assets/open-menu.svg" class="open hover-pointer" @click="open_menu"/>
            </transition>

        <div :class="['edit-container', {'expand-edit': getIsMenuHidden}]" v-if="selected_page === 'products' && ( getAdmin('show_edit') || getAdmin('show_ceil_edit') || getAdmin('show_inner_edit') || getAdmin('show_image_edit') )">
            <p class="edit-close hover-pointer hover-red" @click="getAdminEditThis.close_edit">Закрыть</p>


            <div class="edit" :style="{width: getIsMenuHidden ? '102%' : '101.4%'}" v-if="getAdmin('show_edit') && getAdmin('type') === 'image'">
                <div class="images_upload">
                    <label :for="`file_${getAdminEditThis.options.id}`"><p class="upload nesting-main hover-pointer hover-yellow">Загрузить изображение</p></label>
                    <input type="file" :id="`file_${getAdminEditThis.options.id}`" style="display: none" ref="file" @change="getAdminEditThis.getFile($event.target.files[0])"/>
                    <div class="uploaded flex-row row-space-between row-ver-center nesting-main" v-for="(img, i) in getAdminEditThis.options.images" :key="img.id">
                        <img class="mini-img" :src="img.src"/>
                        <div class="flex-row">
                            <p class="text hover-pointer hover-yellow" @click="getAdminEditThis.up_img(i)">Ниже</p> 
                            <p class="text hover-pointer hover-yellow" @click="getAdminEditThis.down_img(i)">Выше</p> 
                            <p class="text hover-pointer hover-red" @click="getAdminEditThis.delete_img(i)">Удалить</p> 
                        </div>
                    </div>
                </div>
                <div class="input-container" v-for="(style, name) in getAdminEditThis.options.style" :key="name">
                    <p class='text'>{{getAdminEditThis.style_titles[name]}}</p>
                    <input v-show="!getAdminEditThis.style_options[name]" type="text" class="input" v-model="getAdminEditThis.options.style[name]" placeholder="name"/>
                    <select v-show="getAdminEditThis.style_options[name]" class="select" v-model="getAdminEditThis.options.style[name]">
                        <option v-for="option in getAdminEditThis.style_options[name]" :key="option">{{option}}</option>
                    </select>
                </div>
            </div>
            <div class="edit" :style="{width: getIsMenuHidden ? '102%' : '101.4%'}" v-if="getAdmin('show_image_edit') && getAdmin('type') === 'image'">
                <div class="input-container" v-for="(style, name) in getAdminEditThis.editable_image_style" :key="name">
                    <p class='text'>{{getAdminEditThis.image_style_titles[name]}}</p>
                    <input v-show="!getAdminEditThis.image_style_options[name]" type="text" class="input" v-model="getAdminEditThis.editable_image_style[name]" placeholder="name"/>
                    <select v-show="getAdminEditThis.image_style_options[name]" class="select" v-model="getAdminEditThis.editable_image_style[name]">
                        <option v-for="option in getAdminEditThis.image_style_options[name]" :key="option">{{option}}</option>
                    </select>
                </div>
            </div>

            <div class="edit" :style="{width: getIsMenuHidden ? '102%' : '101.4%'}" v-if="getAdmin('show_edit') && ( getAdmin('type') === 'text' || getAdmin('type') === 'table' )">
                    <div class="columns" v-if="getAdmin('type') === 'table'">
                        <p class="title">Настройка ширины столбцов:</p>
                        <div class="table-column flex-row row-ver-center nesting-main" v-for="(column, i) in getAdminEditThis.options.columns" :key="i">
                            <p class="table-text">Столбец {{i}}</p>
                            <input class="mini-input" type="text" v-model="getAdminEditThis.options.ceils.columns[i].width" @change="getAdminEditThis.addUnsavedPage({page: 'products'})"/>
                            <p class="table-text">Расстянуть до заполнения:</p>
                            <input class="mini-checkbox" type="checkbox" v-model="getAdminEditThis.options.ceils.columns[i].flex" @change="getAdminEditThis.addUnsavedPage({page: 'products'})"/>
                            <p class="delete hover-pointer hover-red" @click="getAdminEditThis.delete_column(i, getAdminEditThis.options)">Удалить</p>
                        </div>
                        <p class="add hover-pointer hover-yellow nesting-main" @click="getAdminEditThis.add_column(getAdminEditThis.options)">+ Добавить столбец</p>
                    </div>
                    <div class="rows" v-if="getAdmin('type') === 'table'">
                        <p class="title">Настройка высоты рядов</p>
                        <div class="table-row flex-row row-ver-center nesting-main" v-for="(row, i) in getAdminEditThis.options.columns[0]" :key="i">
                            <p class="table-text">Ряд {{i}}</p>
                            <input class="mini-input" type="text" v-model="getAdminEditThis.options.ceils.rows[i].height" @change="getAdminEditThis.addUnsavedPage({page: 'products'})"/>
                            <p class="table-text">Расстянуть до заполнения:</p>
                            <input class="mini-checkbox" type="checkbox" v-model="getAdminEditThis.options.ceils.rows[i].flex" @change="getAdminEditThis.addUnsavedPage({page: 'products'})"/>
                            <p class="delete hover-pointer hover-red" @click="getAdminEditThis.delete_row(i, getAdminEditThis.options)">Удалить</p>
                        </div>
                        <p class="add hover-pointer hover-yellow nesting-main" @click="getAdminEditThis.add_row(getAdminEditThis.options)">+ Добавить ряд</p>
                    </div>
                    
                    <or-admin-textarea v-if="getAdmin('type') === 'text'" class="item edit-text" :options="getAdminEditThis.options.text" :white_color="true"/>
                    <div class="input-container" v-for="(style, name) in getAdminEditThis.options.style" :key="name">
                        <p class='text'>{{getAdminEditThis.style_titles[name]}}</p>
                        <input v-show="!getAdminEditThis.style_options[name]" type="text" class="input" v-model="getAdminEditThis.options.style[name]" placeholder="name" @change="getAdminEditThis.addUnsavedPage({page: 'products'})"/>
                        <select v-show="getAdminEditThis.style_options[name]" class="select" v-model="getAdminEditThis.options.style[name]" @change="getAdminEditThis.addUnsavedPage({page: 'products'})">
                            <option v-for="option in getAdminEditThis.style_options[name]" :key="option">{{option}}</option>
                        </select>
                    </div>
                    <p class="close" @click="getAdminEditThis.close_edit">Закрыть</p>
                </div>

                <div class="edit" :style="{width: getIsMenuHidden ? '102%' : '101.4%'}" v-if="getAdmin('show_ceil_edit')">
                    <or-admin-textarea v-if="getAdminEditThis.ceil_options.text" class="item" :options="getAdminEditThis.ceil_options.text" :white_color="true"/>
                    <p class="add-table hover-pointer hover-yellow" @click="getAdminEditThis.add_table_to_ceil(getAdminEditThis.ceil_options)">Добавить таблицу в ячейку</p>
                    <p class="delete-table hover-pointer hover-red" @click="getAdminEditThis.delete_table_from_ceil(getAdminEditThis.ceil_options.child ? getAdminEditThis.ceil_options : getAdminEditThis.parent, !getAdminEditThis.ceil_options.child)">Удалить таблицу из родительской ячейки</p>
                    <div v-if="getAdminEditThis.ceil_options.child || getAdminEditThis.parent_options">
                        <div class="columns">
                            <p class="title">Настройка ширины столбцов:</p>
                            <div class="table-column flex-row row-ver-center nesting-main" v-for="(column, i) in getAdminEditThis.ceil_options.child ? getAdminEditThis.ceil_options.child.columns : getAdminEditThis.parent_options.columns" :key="i">
                                <p class="table-text">Столбец {{i}}</p>
                                <input class="mini-input" v-if="getAdminEditThis.ceil_options.child" type="text" v-model="getAdminEditThis.ceil_options.child.ceils.columns[i].width" @change="getAdminEditThis.addUnsavedPage({page: 'products'})"/>
                                <input class="mini-input" v-else type="text" v-model="getAdminEditThis.parent_options.ceils.columns[i].width" @change="getAdminEditThis.addUnsavedPage({page: 'products'})"/>
                                <p class="table-text">Расстянуть до заполнения:</p>
                                <input class="mini-checkbox" v-if="getAdminEditThis.ceil_options.child" type="checkbox" v-model="getAdminEditThis.ceil_options.child.ceils.columns[i].flex" @change="getAdminEditThis.addUnsavedPage({page: 'products'})"/>
                                <input class="mini-checkbox" v-else type="checkbox" v-model="getAdminEditThis.parent_options.ceils.columns[i].flex" @change="getAdminEditThis.addUnsavedPage({page: 'products'})"/>
                                <p class="delete hover-pointer hover-red" @click="getAdminEditThis.delete_column(i, getAdminEditThis.ceil_options.child ? getAdminEditThis.ceil_options.child : getAdminEditThis.parent_options)">Удалить</p>
                            </div>
                            <p class="add hover-pointer hover-yellow nesting-main" @click="getAdminEditThis.add_column(getAdminEditThis.ceil_options.child ? getAdminEditThis.ceil_options.child : getAdminEditThis.parent_options)">+ Добавить столбец</p>
                        </div>
                        <div class="rows">
                            <p class="title">Настройка высоты рядов</p>
                            <div class="table-row flex-row row-ver-center nesting-main" v-for="(row, i) in getAdminEditThis.ceil_options.child ? getAdminEditThis.ceil_options.child.columns[0] : getAdminEditThis.parent_options.columns[0]" :key="i">
                                <p class="table-text">Ряд {{i}}</p>
                                <input class="mini-input" v-if="getAdminEditThis.ceil_options.child" type="text" v-model="getAdminEditThis.ceil_options.child.ceils.rows[i].height" @change="getAdminEditThis.addUnsavedPage({page: 'products'})"/>
                                <input class="mini-input" v-else type="text" v-model="getAdminEditThis.parent_options.ceils.rows[i].height" @change="getAdminEditThis.addUnsavedPage({page: 'products'})"/>
                                <p class="table-text">Расстянуть до заполнения:</p>
                                <input class="mini-checkbox" v-if="getAdminEditThis.ceil_options.child" type="checkbox" v-model="getAdminEditThis.ceil_options.child.ceils.rows[i].flex" @change="getAdminEditThis.addUnsavedPage({page: 'products'})"/>
                                <input class="mini-checkbox" v-else type="checkbox" v-model="getAdminEditThis.parent_options.ceils.rows[i].flex" @change="getAdminEditThis.addUnsavedPage({page: 'products'})"/>
                                <p class="delete hover-pointer hover-red" @click="getAdminEditThis.delete_row(i, getAdminEditThis.ceil_options.child ? getAdminEditThis.ceil_options.child : getAdminEditThis.parent_options)">Удалить</p>
                            </div>
                            <p class="add hover-pointer hover-yellow nesting-main" @click="getAdminEditThis.add_row(getAdminEditThis.ceil_options.child ? getAdminEditThis.ceil_options.child : getAdminEditThis.parent_options)">+ Добавить ряд</p>
                        </div>
                    </div>
                    <div class="input-container" v-for="(style, name) in getAdminEditThis.ceil_options.style" :key="name">
                        <p class='text'>{{getAdminEditThis.ceil_style_titles[name]}}</p>
                        <input v-show="!getAdminEditThis.ceil_style_options[name]" type="text" class="input" v-model="getAdminEditThis.ceil_options.style[name]" placeholder="name" @change="getAdminEditThis.addUnsavedPage({page: 'products'})"/>
                        <select v-show="getAdminEditThis.ceil_style_options[name]" class="select" v-model="getAdminEditThis.ceil_options.style[name]">
                            <option v-for="option in getAdminEditThis.ceil_style_options[name]" :key="option">{{option}}</option>
                        </select>
                    </div>
                </div>


            </div>
        </div>
        
        
        <div class="all-screen" v-if="getAdmin('edit_menu').show" @click.self="changeAdmin({property: 'edit_menu', value: {show: false, top: 0, left: 0, this_ctx: null}})"></div>
        <div v-show="getAdmin('edit_menu').show" class="edit-menu flex-row" ref="edit-menu" :style="{left: getAdmin('edit_menu').left, top: getAdmin('edit_menu').top}">
            <img class="icon edit-icon hover-pointer" title="Редактировать" @click="getAdmin('edit_menu').this_ctx.open_edit()" src="../../assets/edit-icon.svg"/>
            <img class="icon up-icon direction hover-pointer" title="Выше" @click="getAdmin('edit_menu').this_ctx.move_up()" src="../../assets/up-icon.svg"/>
            <img class="icon down-icon direction hover-pointer" title="Ниже" @click="getAdmin('edit_menu').this_ctx.move_down()" src="../../assets/down-icon.svg"/>
            <img class="icon remove-icon direction hover-pointer" title="Удалить" @click="getAdmin('edit_menu').this_ctx.delete_item()" src="../../assets/delete-icon.svg"/>
            <p class="close hover-pointer hover-yellow" @click="changeAdmin({property: 'edit_menu', value: {show: false, top: 0, left: 0, this_ctx: null}})">Закрыть</p>
        </div>

        
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import orAdminHeader from "./parts/or-admin-header.vue"
    import orAdminMenu from "./parts/or-admin-menu.vue"
    import orAdminSaveButton from "./parts/or-admin-save-button.vue"
    import orAdminAuth from "./parts/or-admin-auth.vue"
    import orAdminContent from "./parts/or-admin-content.vue"
    import orAdminMain from "./parts/menu/or-admin-main.vue"
    import orAdminAbout from "./parts/menu/or-admin-about.vue"
    import orAdminProduction from "./parts/menu/or-admin-production.vue"
    import orAdminBuyers from "./parts/menu/or-admin-buyers.vue"
    import orAdminNews from "./parts/menu/or-admin-news.vue"
    import orAdminContacts from "./parts/menu/or-admin-contacts.vue"
    import orAdminProducts from "./parts/menu/or-admin-products.vue"
    import orAdminInfo from "./parts/menu/or-admin-info.vue"
    import orAdminTextarea from "./parts/global/or-admin-textarea.vue"
    import Axios from 'axios'
    export default {
        components: {
            orAdminHeader, 
            orAdminMenu, 
            orAdminSaveButton, 
            orAdminAuth,
            orAdminContent, 
            orAdminMain, 
            orAdminAbout, 
            orAdminProduction, 
            orAdminBuyers, 
            orAdminNews, 
            orAdminContacts, 
            orAdminProducts, 
            orAdminInfo,
            orAdminTextarea
        },
        data() {
            return {
                auth: false,
                selected_page: 'main',
                production_categories: {},
                buyers_categories: {},
                show_menu_button: false,
                loaded: {
                    main: false,
                    about: false,
                    production: false,
                    buyers: false,
                    news: false,
                    contacts: false,
                    products: false,
                    info: false,
                },
                options: {
                    deleted: {
                        buyers: [],
                        production: [],
                        news: [],
                        products: [],
                    },
                    main: {
                        'main-title': {title: 'Главный заголовок', value: ''},
                        'description': {title: 'Описание', value: ''},
                        'services-title': {title: 'Заголовок услуг', value: ''},
                    },
                    about: [],
                    production: [],
                    buyers: [],
                    news: [],
                    contacts: {
                        'phone-text': {title: 'Текст перед телефоном', value: ''},
                        'placemark': {title: 'Координаты точки на карте', value: ''},
                        'coords': {title: 'Координаты центра карты', value: ''},
                    },
                    products: [],
                    info: {
                        'phone': {title: 'Телефон', value: ''},
                        'phone-1': {title: 'Телефон директора', value: ''},
                        'phone-2': {title: 'Телефон коммерческого директора', value: ''},
                        'phone-3': {title: 'Телефон технического директора', value: ''},
                        'adress': {title: 'Адрес', value: ''},
                        'email': {title: 'Почта', value: ''},
                        'director': {title: 'Директор', value: ''},
                        'feedback-email': {title: 'Почта для писем с сайта', value: ''},
                        'service': {title: 'Почтовый сервис', value: ''},
                        'user': {title: 'Логин', value: ''},
                        'pass': {title: 'Лже-пароль приложения', value: ''},
                    },
                }
            }
        },
        mounted() {
            Axios.get('/api/isLogin') 
            .then(({data})=>{
                if (data) {
                    this.auth = data;
                }
            })
            .then(()=>{
                if (this.auth) {
                    this.getInfo();
                    Axios.post('/api/getNews') 
                    .then(({data})=>{
                        if (data) {
                            this.getNews(data);
                            this.loaded.news = true;
                        }
                    })
                    
                    this.getCategories();


                    Axios.post('/api/getAbout') 
                    .then(({data})=>{
                        if (data) {
                            this.getAbout(data);
                        this.loaded.about = true;
                        }
                    })
                    Axios.post('/api/getSiteInfo') 
                    .then(({data})=>{
                        if (data) {
                        this.loaded.main = true;
                        this.loaded.contacts = true;
                        this.loaded.info = true;
                        }
                    })
                }
            })

            

        },    
        computed: {
            ...mapGetters({unsaved: 'getUnsaved', getAdmin: 'getAdmin', getAdminEditThis: 'getAdminEditThis', getIsMenuHidden: 'getIsMenuHidden'}),
        },
        methods: {
            ...mapActions({emit: 'emit', changeAdmin: 'changeAdmin', changeIsMenuHidden: 'changeIsMenuHidden'}),
            // push_unsaved(page) {
            //     if (!this.unsaved.includes(page)) {
            //         this.unsaved.push(page);
            //     }
            // },
            // splice_unsaved(page) {
            //     const index = this.unsaved.indexOf(page);
            //     if (index !== '-1') {
            //         this.unsaved.splice(index, 1);
            //     }
            // },
            login() {
                this.auth = true;
                Axios.post('/api/getNews') 
                .then(({data})=>{
                    if (data) {
                        this.getNews(data);
                        this.loaded.news = true;
                    }
                })
                
                this.getCategories();


                this.getInfo();
                Axios.post('/api/getAbout') 
                .then(({data})=>{
                    if (data) {
                        this.getAbout(data);
                        this.loaded.about = true;
                    }
                })
                Axios.post('/api/getSiteInfo') 
                .then(({data})=>{
                    if (data) {
                        this.loaded.main = true;
                        this.loaded.contacts = true;
                        this.loaded.info = true;
                    }
                })
            },
            logout() {
                Axios.get('/api/logout');
                this.auth = false;
                this.$refs.auth.isLoginInProcess = false;
            },
            getCategories() {
                Axios.post('/api/getProduction') 
                    .then(({data})=>{
                        if (data) {
                            this.getProduction(data);
                            this.loaded.production = true;
                        }
            
                    Axios.post('/api/getBuyers') 
                            .then(({data})=>{
                                if (data) {
                                    this.getBuyers(data);
                                    this.loaded.buyers = true;
                                }
                                Axios.post('/api/getProducts') 
                                    .then(({data})=>{
                                        if (data) {
                                            this.getProducts(data);
                                            this.loaded.products = true;
                                        }
                                    })
                            })
                    })
            },
            open_menu() {
                this.show_menu_button = false;
                this.$refs.menu.$refs.menu.style.width = '256px';
                this.narrow_content();
                this.changeIsMenuHidden({value: false})
            },
            expand_content() {
                this.$refs.content.$refs.content.style.width = '1200px';
                this.$refs.content.$refs.content.style.right = 0;
                this.$refs.content.$refs.slot.style.width = '101.4%';
            },
            narrow_content() {
                this.$refs.content.$refs.content.style.width = '870px';
                this.$refs.content.$refs.content.style.right = '40px';
                this.$refs.content.$refs.slot.style.width = '102%';
            },
            getInfo() {     
                Axios.post('/api/getInfoForAdminPanel')
                    .then(({data})=>{
                        for (const key in this.options.main) {
                            this.options.main[key].value = data[key];
                        }
                        
                        for (const key in this.options.contacts) {
                            this.options.contacts[key].value = data[key];
                        }
                        
                        for (const key in this.options.info) {
                            this.options.info[key].value = data[key];
                        }
                    })
            },
            getNews(data) {
                data.map(el=>{
                    this.options.news.push({
                        id: el.id,
                        title: {
                            title: 'Заголовок',
                            value: el.title,
                        },
                        text: {
                            title: 'Текст новости',
                            value: el.text,
                        },
                        date: {
                            title: 'Дата публикации',
                            value: el.date,
                        },
                    })
                })
            },
            getProduction(data) {
                this.production_categories = {};
                this.options.production = [];
                data.map(el=>{
                    const sort = el.sort.sort;
                    this.production_categories[el.id] = {
                        id: el.id,
                        name: el.category,
                        products: [],
                        products_sort: sort,
                    }
                    this.options.production.push({
                        id: el.id,
                        title: 'Название категории',
                        value: el.category,
                        image: el.image,
                        input_postfix: 'production',
                        products_sort: sort,
                    })
                })
            },
            getBuyers(data) {
                this.buyers_categories = {};
                this.options.buyers = [];
                data.map(el=>{
                    const sort = el.sort.sort;
                    this.buyers_categories[el.id] = {
                        id: el.id,
                        name: el.category,
                        products: [],
                        products_sort: sort,
                    }
                    this.options.buyers.push({
                        id: el.id,
                        title: 'Название категории',
                        value: el.category,
                        image: el.image,
                        input_postfix: 'buyers',
                        products_sort: sort,
                    })
                })
            },
            getProducts(data) {
                this.options.products = [];

                data.map(el=>{
                    if (this.production_categories[el.production_category_id]) {
                        this.production_categories[el.production_category_id].products.push(
                            {
                                name: el.name,
                                id: el.id,
                            }
                        ); 
                    } else {
                        el.production_category_id = -1; 
                    }

                    const toDelete = [];
                    for (let index in el.buyers_category_id) {
                        const key = el.buyers_category_id[index];
                        if(this.buyers_categories[key]) {
                            this.buyers_categories[key].products.push(
                                {
                                    name: el.name,
                                    id: el.id,
                                }
                            );
                        } else {
                            toDelete.push(+index);
                        }
                    }


                    if (toDelete.length > 0) {
                        el.buyers_category_id = el.buyers_category_id.filter((el, index)=> {
                            return !toDelete.includes(+index)
                            })
                    }

                    this.options.products.push({
                        id: el.id,
                        title: {
                            title: 'Название изделия',
                            value: el.name,
                        },
                        description: {
                            title: 'Краткое описание изделия',
                            value: el.description,
                        },
                        image: el.image,
                        content: el.content,
                        production_category_id: el.production_category_id,
                        production_category_name: el.production_category_id !== -1 ? this.production_categories[el.production_category_id].name : null,
                        buyers_category_id: el.buyers_category_id,
                        // buyers_category_name: el.buyers_category_id !== -1 ? this.buyers_categories[el.buyers_category_id].name : null,
                        production_categories: this.production_categories,
                        buyers_categories: this.buyers_categories,
                        input_postfix: 'product', 
                    })
                })
                this.sort_products_in_categories(this.production_categories);
                this.sort_products_in_categories(this.buyers_categories);
                this.options.production.products = this.production_categories;
                this.options.buyers.products = this.buyers_categories;
            },
            sort_products_in_categories(categories) {
                for (const index in categories) {
                    const category = categories[index];
                    const sorted_products = [];
                    const unsorted_products = [];
                    category.products.map(product=>{
                        if (category.products_sort.includes(product.id)) {
                            sorted_products.splice(category.products_sort.indexOf(product.id),0,product.id);
                        } else {
                            unsorted_products.push(product.id);
                        }
                    })
                    unsorted_products.map(el=>{
                        sorted_products.push(el);
                    })
                    category.products_sort.length = 0;
                    category.products_sort.push(...sorted_products);
                }
            },
            getAbout(data) {
                if (!data) {
                    this.options.about = [];
                } else {
                    this.options.about = data;
                }
            }
        }
    }
</script>

<style scoped>
    .main-admin-component {
        min-width: 1200px;
        width: 100vw;
        /* max-width: 100%; */
        min-height: 100vh;
        overflow: hidden;
        color: #000000;
    }
    .body {
        position: relative;
        margin: 0 auto;
        width: 1200px;
        height: calc(100vh - 60px);
        overflow: hidden;
        background-color: #eff6fb;
    }
    .warn {
        position: absolute;
        font-size: 14px;
        height: 16px;
        color: #de1500;
        right: 230px;
        top: 48px;
    }
    .edit-menu {
        position: absolute;
        padding: 10px;
        background-color: #1f1f1f;
        border-radius: 8px;
        border: white 1px solid;
        z-index: 99999999999;
    }
    .icon {
        width: 20px;
        margin-right: 10px;
    }
    .icon:last-of-type {
        margin-right: 0;
    }
    .close {
        position: absolute;
        top: -20px;
        right: 0px;
        font-size: 14px;
        line-height: 16px;
        color: white;
        background-color: #1f1f1f;
        padding: 3px 5px 0 5px;
        box-sizing: border-box;
    }
    .open {
        position: absolute;
        top: 515px;
        left: -3px;
        color: black;
        background-color: white;
        border-radius: 0 5px 5px 0;
        padding: 1px;
        box-sizing: border-box;
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.2s ease;
    }
    .fade-leave-to {
        opacity: 0;
    }
    .input-container {
        margin-bottom: 20px;
    }
    .text {
        text-align: left;
        margin-left: 17px;
        margin-bottom: 5px;
    }
    .input {
        padding: 0 15px;
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        border-radius: 8px;
        border: gray 1px solid;
        outline: none;
    }
    .select {
        padding: 0 15px;
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        border-radius: 8px;
        border: gray 1px solid;
        outline: none;
    }
    .item {
        margin-bottom: 20px;
    }
    .edit-container {
        transition-duration: 150ms;
        position: absolute;
        bottom: 0px;
        width: 870px;
        right: 40px;
        height: 30vh;
        /* padding: 30px; */
        background-color: #1f1f1f;
        box-sizing: border-box;
        overflow: hidden;
        color: white;
        font-size: 14px;
        line-height: 16px;
    }
    .edit {
        width: 102%;
        padding: 30px;
        height: 30vh;
        box-sizing: border-box;
        overflow-x: hidden;
        overflow-y: scroll;
    }
    .edit-close {
        top: -20px;
        right: 0px;
        font-size: 14px;
        line-height: 16px;
        color: #1f1f1f;
        background-color: white;
        padding: 3px 5px 0 5px;
        box-sizing: border-box;
        padding: 5px;
    }
    .edit-text {
        color: white;
    }

    
    .table {
        position: relative;
        width: 100%;
        height: 100%;
    }
    .column {
        height: 100%;
        border-right:#EBB932 1px solid;
        position: relative;
        display: flex-block;
    }
    .column:last-of-type {
        border-right: none;
    }
    .row {
        position: relative;
        border-bottom:#EBB932 1px solid;
        width: 100%;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: auto;
    }
    .row:last-of-type {
        border-bottom: none;
    }
    .row-inner {
        border-right: none;
    }
    .row-inner:last-of-type {
        border-bottom: none;
    }
    
    .text {
        text-align: left;
        margin-left: 17px;
        margin-bottom: 5px;
    }
    .input {
        padding: 0 15px;
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        border-radius: 8px;
        border: gray 1px solid;
        outline: none;
    }
    .table-column, .table-row {
        margin-bottom: 10px;
    }
    .title {
        text-align: left;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .delete {
        color: gray;
        margin-left: 15px;
    }
    .add {
        text-align: left;
        margin-bottom: 30px;
        margin-top: 20px;
    }
    .select {
        padding: 0 15px;
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        border-radius: 8px;
        border: gray 1px solid;
        outline: none;
    }
    .item {
        margin-bottom: 20px;
    }
    .mini-input {
        width: 40px;
        height: 30px;
        outline: none;
        border: gray 1px solid;
        border-radius: 8px;
        padding: 0 10px;
        margin-left: 20px;
        margin-right: 20px;
    }
    .mini-checkbox {
        margin-left: 10px;
        margin-right: 20px;
    }
    .add-table {
        text-align: left;
        margin-top: 30px;
        margin-bottom: 20px;
    }
    .delete-table {
        text-align: left;
        margin-bottom: 30px;
    }
    .upload {
        text-align: left;
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 30px;
    }
    .uploaded {
        width: 280px;
        height: 50px;
        margin-bottom: 50px;
    }
    .mini-img {
        width: 80px;
        height: 50px;
        object-fit: cover;
        object-position: center;
    }
    .expand-edit {
        width: 1200px !important;
        right: 0 !important;
    }
</style>